<template>
  <div class="layout">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "home",
  data() {
    return {
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.layout {
  // position: relative;
  width: 100%;
  height: 100%;
}
</style>
